import { Box, Grid, Paper } from '@atgfr8/atg-ui-tailwind';
import {
  FalveyInsuranceQuote,
  LtlQuoteParametersViewModel,
  LtlQuoteViewModel,
} from '@store/orders/types';

import { QuoteCarrierDetailsLegacy } from './QuoteCarrierDetailsLegacy';
import { QuoteCostDetailsLegacy } from './QuoteCostDetailsLegacy';

export function QuoteDetailsRowRenderLegacy(
  props: Readonly<{
    quoteParameters: LtlQuoteParametersViewModel;
    quote: LtlQuoteViewModel;
    insuranceQuote?: FalveyInsuranceQuote;
    isHistory: boolean;
    customerId: number;
    testMode?: boolean;
  }>,
) {
  const hasInsurance = (props.insuranceQuote?.premium ?? 0) > 0;

  return (
    <Box p={2} mb={2}>
      <Grid container spacing={2}>
        {/* Carrier Details Card */}
        <Grid item size={{ xs: 12, lg: hasInsurance ? 7 : 8 }}>
          <Paper elevation={3} class="px-3! py-4! h-full w-full">
            <QuoteCarrierDetailsLegacy
              quote={props.quote}
              testMode={Boolean(props.testMode)}
            />
          </Paper>
        </Grid>

        {/* Main Cost Details Card */}
        <Grid item size={{ xs: 12, lg: hasInsurance ? 2.5 : 4 }}>
          <Paper elevation={3} class="px-3! py-4! h-full w-full">
            <QuoteCostDetailsLegacy
              quoteParameters={props.quoteParameters}
              quote={props.quote}
              customerId={props.customerId}
              isInsuranceRequest={false}
              insuranceQuote={props.insuranceQuote}
              isHistory={props.isHistory}
              testMode={Boolean(props.testMode)}
            />
          </Paper>
        </Grid>

        {/* Insurance Cost Details Card (conditionally rendered) */}
        {hasInsurance && (
          <Grid item size={{ xs: 12, lg: 2.5 }}>
            <Paper elevation={3} class="px-3! py-4! h-full w-full">
              <QuoteCostDetailsLegacy
                quoteParameters={props.quoteParameters}
                quote={props.quote}
                insuranceQuote={props.insuranceQuote}
                customerId={props.customerId}
                isInsuranceRequest={true}
                isHistory={props.isHistory}
                testMode={Boolean(props.testMode)}
              />
            </Paper>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}
